<template>
  <div id="customerAdd">
    <van-form
      ref="form"
      @submit="onSubmit"
      label-width="110px"
      input-align="right"
    >
      <van-field
        required
        v-model="form.phone"
        type="tel"
        name="phone"
        label="手机号"
        placeholder="点击填写"
        maxlength="11"
        :rules="[
          { required: true, message: '请填写手机号' },
          { validator: validPhone, message: '请输入正确手机号' },
          { validator: validPhoneRepeat, message: '手机号已存在' },
        ]"
      />
      <van-field
        required
        readonly
        clickable
        name="sotreId"
        :value="storeText"
        label="门店"
        placeholder="点击选择>"
        @click="showStore = true"
        :rules="[{ required: true, message: '请选择门店' }]"
      />
      <van-field
        required
        v-model="form.name"
        name="name"
        label="姓名"
        placeholder="点击填写"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field required name="性别" label="性别">
        <template #input>
          <van-radio-group v-model="form.gender" direction="horizontal">
            <van-radio name="1">男</van-radio>
            <van-radio name="0">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        required
        v-model="form.persons"
        type="digit"
        name="persons"
        label="入住人数"
        placeholder="点击填写"
        :rules="[{ required: true, message: '请填写入住人数' }]"
      />
      <van-field
        required
        readonly
        clickable
        name="picker"
        :value="form.budget"
        label="期望月租"
        placeholder="点击选择>"
        @click="showBudget = true"
        :rules="[{ required: true, message: '请选择期望月租' }]"
      />
      <van-field
        required
        readonly
        clickable
        name="picker"
        :value="sourceText"
        label="来源"
        placeholder="点击选择>"
        @click="showSource = true"
        :rules="[{ required: true, message: '请选择来源' }]"
      />
        <van-field required name="是否分销客户" label="是否分销客户"
         :rules="[{ required: true, message: '请选择是否分销客户' }]"
        >
        <template #input>
          <van-radio-group v-model="form.isDistribution" direction="horizontal">
            <van-radio name="1">是</van-radio>
            <van-radio name="0">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="form.remark"
        rows="2"
        autosize
        label="其他需求"
        type="textarea"
        maxlength="50"
        placeholder="请输入其他需求"
        show-word-limit
      />
      <van-field
        readonly
        clickable
        name="picker"
        :value="
          trackRecordList.find((d) => {
            return d.code == form.status;
          })
            ? trackRecordList.find((d) => {
                return d.code == form.status;
              }).desc
            : ''
        "
        label="跟进状态"
        placeholder="点击选择>"
        @click="showStatus = true"
      />
      <van-field
        v-model="form.statusRemark"
        rows="2"
        autosize
        label="跟进备注"
        type="textarea"
        maxlength="50"
        placeholder="请输入跟进备注"
        show-word-limit
      />
      <van-field
        readonly
        clickable
        name="idType"
        :value="idTypeList[form.idType - 1]"
        label="证件类型"
        placeholder="点击选择>"
        @click="showIdType = true"
      />
      <van-field
        v-model="form.idNo"
        type="text"
        name="idNo"
        label="证件号码"
        placeholder="点击填写"
      />
      <van-field
        v-model="form.email"
        name="email"
        type="email"
        label="电子邮箱"
        placeholder="点击填写"
      />
      <van-field
        v-model="form.contactName"
        name="contactName"
        label="紧急联系人姓名"
        placeholder="点击填写"
      />
      <van-field
        readonly
        clickable
        name="contactRelation"
        :value="contactList[form.contactRelation - 1]"
        label="紧急联系人关系"
        placeholder="点击选择>"
        @click="showContact = true"
      />
      <van-field
        v-model="form.contactPhone"
        name="contactPhone"
        type="tel"
        label="紧急联系人电话"
        placeholder="点击填写"
        maxlength="11"
              
      />
      
         <!-- :rules="[
>>>>>>> e90148b8065a2da319f447595808fbd9a3dbba3d
            { required: true, message: '请填写紧急联系人电话' },

            { validator: validPhone, message: '请输入正确手机号' },

            {
              validator: (item) => {
                return Boolean(form.contactPhone != form.phone);
              },

              message: '紧急联系人电话不可与租客相同',
            },
          ]"  -->
      <div style="height: 1.2rem"></div>
      <div class="btn">
        <van-button
          round
          block
          type="primary"
          :loading="saveLoad"
          :disabled="saveLoad"
          native-type="submit"
          >保存</van-button
        >
      </div>
    </van-form>
    <!-- 门店 -->
    <van-popup v-model="showStore" position="bottom">
      <van-picker
        show-toolbar
        :columns="storeList"
        value-key="name"
        @confirm="
          (item) => {
            storeText = item.name;
            form.storeId = item.id;
            showStore = false;
          }
        "
        @cancel="showStore = false"
      />
    </van-popup>
    <!-- 期望月租 -->
    <van-popup v-model="showBudget" position="bottom">
      <van-picker
        show-toolbar
        :columns="budgetList"
        value-key="label"
        @confirm="
          (item) => {
            form.budget = item.label;
            showBudget = false;
          }
        "
        @cancel="showBudget = false"
      />
    </van-popup>
    <!-- 来源 -->
    <van-popup v-model="showSource" position="bottom">
      <van-picker
        show-toolbar
        :columns="sourceList"
        value-key="name"
        @confirm="
          (item) => {
            sourceText = item.name;
            form.sourceId = item.id;
            showSource = false;
          }
        "
        @cancel="showSource = false"
      />
    </van-popup>
    <!-- 跟进状态 -->
    <van-popup v-model="showStatus" position="bottom">
      <van-picker
        show-toolbar
        :columns="trackRecordList"
        value-key="desc"
        @confirm="
          (item, index) => {
            form.status = item.code;
            showStatus = false;
          }
        "
        @cancel="showStatus = false"
      />
    </van-popup>
    <!-- 证件类型 -->
    <van-popup v-model="showIdType" position="bottom">
      <van-picker
        show-toolbar
        :columns="idTypeLists"
        @confirm="
          (item, index) => {
            form.idType = item.value;
            showIdType = false;
            $refs.form.resetValidation('idNo');
          }
        "
        @cancel="showIdType = false"
      />
    </van-popup>
    <!-- 紧急联系人关系 -->
    <van-popup v-model="showContact" position="bottom">
      <van-picker
        show-toolbar
        :columns="contactList"
        @confirm="
          (item, index) => {
            form.contactRelation = index / 1 + 1;
            showContact = false;
          }
        "
        @cancel="showContact = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { validPhone, validEmail, validIdNo } from "@/utils/validate";
import {
  requestCustomerAdd,
  requestSourceList,
  requestBudget,
  requestPCStore,
  requestPhoneRepeat,
  requestChildStatus,
} from "@/api";
export default {
  name: "customerAdd",
  data() {
    return {
      form: {
        phone: "", //电话
        storeId: "", //门店
        name: "", //姓名
        gender: "1", //1男  0女
        persons: "", //入住人数
        budget: "", //期望月租
        sourceId: "", //来源
        isDistribution:"",
        remark: "", //其他需求
        status: "", //状态
        statusRemark: "", //备注
        idType: "", //证件类型
        idNo: "", //证件号码
        orgName: "", //企业名称
        orgNo: "", //企业号码
        email: "", //电子邮箱
        contactName: "", //紧急联系人姓名
        contactPhone: "", //紧急联系人电话
        contactRelation: "", //紧急联系人关系
      },
      saveLoad: false,
      storeText: "",
      // budgetText: "",
      sourceText: "",
      showStore: false,
      showBudget: false,
      showSource: false,
      showStatus: false,
      showIdType: false,
      showContact: false,
      storeList: [], //门店
      budgetList: [], //期望月租下拉
      sourceList: [], //来源下拉
      trackRecordList: [], //跟进状态下拉
      idTypeList1: ["身份证", "港澳台通行证", "护照"],
      idTypeLists: [
        { text: "身份证", value: "1" },
        { text: "港澳通行证", value: "2" },
        { text: "护照", value: "3" },
        { text: "台湾通行证", value: "7" },
      ],
      // idTypeList:['居民身份证','护照','港澳台居民身份证','旅行证据','其他'],//1:居民身份证，2:护照，3:港澳台居民身份证，4:旅行证据，5:其他'
    };
  },
  computed: {
    ...mapState([
      "idTypeList",
      "destineList",
      "payList",
      "contractList",
      "contactList",
      "customerList",
    ]),
  },
  created() {
    this.getSource();
    this.getBudget();
    this.getPCStore();
    this.getTrackRecord();
  },
  mounted() {},
  methods: {
    //跟踪记录状态
    getTrackRecord() {
      requestChildStatus({ status: "201" }).then((res) => {
        this.trackRecordList = res.data;
      });
    },
    //请求当前登录人当前公司下门店
    getPCStore() {
      requestPCStore().then((res) => {
        this.storeList = res.data || [];
      });
    },
    //请求期望月租下拉
    getBudget() {
      requestBudget().then((res) => {
        this.budgetList = res.data;
      });
    },
    //请求来源下拉
    getSource() {
      requestSourceList().then((res) => {
        res.data.forEach(item=>{
                        if(item.id == 12|| item.id == 13){
                            item.disabled= true
                        }
                    })
        this.sourceList = res.data ? res.data : [];
      });
    },
    //新增
    onSubmit() {
      this.saveLoad = true;
      requestCustomerAdd(this.form)
        .then((res) => {
          this.saveLoad = false;
          this.$toast.success({
            message: "新增成功",
            forbidClick: true,
            onClose: () => {
              this.$router.back();
            },
          });
        })
        .catch((err) => {
          this.saveLoad = false;
          console.log(err);
        });
    },
    //校验
    validPhoneRepeat(val) {
      this.saveLoad = true;
      return new Promise((resolve) => {
        requestPhoneRepeat(val)
          .then((res) => {
            this.saveLoad = false;
            if (res.data && res.data != this.form.id) {
              this.showStore = false;
              this.showBudget = false;
              this.showSource = false;
              this.showStatus = false;
              this.$dialog
                .confirm({
                  title: "提示",
                  message: "手机号重复",
                  confirmButtonText: "查看客户",
                  cancelButtonText: "返回修改",
                })
                .then(() => {
                  this.$router.push({
                    path: "customerDetail",
                    query: { id: res.data },
                  });
                  // on confirm
                })
                .catch(() => {
                  // on cancel
                });
              resolve(false);
            } else {
              resolve(true);
            }
          })
          .catch((err) => {
            this.saveLoad = false;
          });
      });
    },
    validPhone(val) {
      return validPhone(val);
    },
    validEmail(val) {
      return validEmail(val);
    },
    validIdNo(val) {
      if (this.form.idType == 1) {
        return validIdNo(val);
      } else {
        return true;
      }
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
.body {
  .remark {
    background: #fff;
    padding: 0.4rem 1rem;
    font-size: 0.35rem;
    text-align: left;
    border-bottom: 1px solid #ececec;
    textarea {
      border: none;
      width: 100%;
      margin-top: 0.2rem;
    }
  }
  .slot {
    .gender {
      * {
        vertical-align: text-bottom;
      }
    }
    .placeholder {
      color: #cccccc;
    }
  }
}
.btn {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  border-radius: 0.1rem;
  overflow: hidden;
  display: flex;
  /deep/.van-button {
    margin-left: -1px;
    border: none;
    border-radius: 0;
    flex: 1;
    &:not(:last-child)::after {
      height: 50%;
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      border-right: 0.02667rem solid #ebedf0;
      z-index: 99;
    }
  }
  .font4 {
    width: 2.4rem;
  }
  .font3 {
    width: 1.8rem;
  }
  .font5 {
    width: 51%;
  }
  .font1 {
    width: 100%;
    margin-left: 0;
  }
}
/deep/.van-field__error-message {
  text-align: right;
}
</style>
